import { ACCEPT_PAYMENTS } from '@/common/permissionConstants';
import { useDevOnly } from '@/composables/useDevOnly';

const devOnlyGuard = () => {
    const { isRcmRailPreview } = useDevOnly();
    if (!isRcmRailPreview()) return { name: 'home' };
};

export default [
    {
        path: 'payments',
        name: 'payments',
        meta: { label: 'Payments', hasPermission: ACCEPT_PAYMENTS },
        component: () => import('@/views/PaymentsPage.vue'),
        beforeEnter: devOnlyGuard,
    },
];
